<script>
export default {
    name: 'IconForm',
}
</script>
<template>
    <svg role="img"
        class="base-icon icon-form"
        viewBox="0 0 64 64"
        xmlns="http://www.w3.org/2000/svg"
    >
        <path
            d="M52 8v48H12V8h40zM35.986 23.783L20.807 38.962v4.5h4.5l15.178-15.18-4.499-4.5zm5.321-5.321l-3.2 3.2 4.5 4.499 3.2-3.2-4.5-4.5z"
            fill="currentColor"
            fill-rule="evenodd"
        />
    </svg>
</template>
